<section class="page-title-area">
  <div class="container">
    @for (pageTitle of pageTitleArea; track pageTitle) {
      <div class="page-title-content">
        <h1>{{pageTitle.title}}</h1>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li>{{pageTitle.title}}</li>
        </ul>
      </div>
    }
  </div>
  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
  <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
  <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="contact-info-area pt-100 pb-70">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        @for (InfoBox1 of contactInfoBox1; track InfoBox1) {
          <div class="contact-info-box">
            <div class="back-icon">
              <i class='{{InfoBox1.icon}}'></i>
            </div>
            <div class="icon">
              <i class='{{InfoBox1.icon}}'></i>
            </div>
            <h3>{{InfoBox1.title}}</h3>
            <p>{{InfoBox1.location}}</p>
          </div>
        }
      </div>
      <div class="col-lg-4 col-md-6">
        @for (InfoBox2 of contactInfoBox2; track InfoBox2) {
          <div class="contact-info-box">
            <div class="back-icon">
              <i class='{{InfoBox2.icon}}'></i>
            </div>
            <div class="icon">
              <i class='{{InfoBox2.icon}}'></i>
            </div>
            <h3>{{InfoBox2.title}}</h3>
            <p>Mobile: <a href="tel:{{InfoBox2.number}}">{{InfoBox2.number}}</a></p>
            <p>E-mail: <a href="mailto:{{InfoBox2.email}}">{{InfoBox2.email}}</a></p>
          </div>
        }
      </div>
      <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
        @for (InfoBox3 of contactInfoBox3; track InfoBox3) {
          <div class="contact-info-box">
            <div class="back-icon">
              <i class='{{InfoBox3.icon}}'></i>
            </div>
            <div class="icon">
              <i class='{{InfoBox3.icon}}'></i>
            </div>
            <h3>{{InfoBox3.title}}</h3>
            <p>{{InfoBox3.text1}}</p>
            <!-- <p>{{InfoBox3.text2}}</p> -->
          </div>
        }
      </div>
    </div>
  </div>
</section>

<section class="contact-area pb-100">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <span class="sub-title"><img src="assets/img/star-icon.png" alt="image"> {{sectionTitleContent.subTitle}}</span>
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}}</p>
      </div>
    }
    <div class="calendly-cta">
      <a class="default-btn" [href]="calendlyUrl" target="_blank" rel="noopener noreferrer">
        <i class="bx bx-calendar"></i> Schedule a Call<span></span>
      </a>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        @for (Image of contactImage; track Image) {
          <div class="contact-image">
            <img [src]="Image.img" alt="Devotory office location">
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="contact-form">
          <form id="contactForm">
            <div class="row">
              <div class="col-lg-12 col-md-6">
                <div class="form-group mb-3">
                  <input type="text" name="name" class="form-control" id="name" placeholder="Your name">
                </div>
              </div>
              <div class="col-lg-12 col-md-6">
                <div class="form-group mb-3">
                  <input type="email" name="email" class="form-control" id="email" placeholder="Your email address">
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group mb-3">
                  <input type="text" name="phone_number" class="form-control" id="phone_number" placeholder="Your phone number">
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group mb-3">
                  <textarea name="message" id="message" class="form-control" cols="30" rows="6" placeholder="Write your message..."></textarea>
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <button type="submit" class="default-btn"><i class="flaticon-tick"></i>Send Message<span></span></button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="map">
  <iframe src="https://www.google.com/maps?q=30+N+Gould+St,+Sheridan,+WY+82801,+USA&output=embed" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>